import React from 'react';
import { Icon } from '@iconify/react';

const UnitCountOne = ({
  totalUsers,
  totalFarmerCountVariation,
  newSignUps,
  activeUsers,
  yesterdaysActiveUserCount,
  weatherAlerts,
  yesterdaysWeatherCount,
  cropAdvisoryAlerts,
  yesterdaysAdvisoryCount,
}) => {
  return (
    <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 row-cols-xxl-5 g-3">
      <div className="col">
        <div className="card shadow-none border h-100">
          <div className="card-body p-3">
            <div className="d-flex justify-content-between align-items-start gap-3 mb-2">
              <div className="min-w-0">
                <p className="text-muted fw-medium mb-3">Total Farmers</p>
                <h4 className="mb-0 text-break">{totalUsers}</h4>
              </div>
              <div className="bg-primary bg-opacity-10 p-2 rounded flex-shrink-0">
                <Icon icon="fluent-color:people-list-20" className="text-primary" width="24" />
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-between mt-3 gap-2 flex-wrap">
              <span className="text-success fw-medium d-flex align-items-center">
                +{totalFarmerCountVariation}%
              </span>
              <span className="text-muted small text-capitalize">From last month</span>
            </div>
          </div>
        </div>
      </div>

      <div className="col">
        <div className="card shadow-none border h-100">
          <div className="card-body p-3">
            <div className="d-flex justify-content-between align-items-start gap-3 mb-2">
              <div className="min-w-0">
                <p className="text-muted fw-medium mb-3">New Sign Ups</p>
                <h4 className="mb-0 text-break">{newSignUps}</h4>
              </div>
              <div className="bg-warning bg-opacity-10 p-2 rounded flex-shrink-0">
                <Icon icon="fluent-color:people-team-48" className="text-warning" width="24" />
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-between mt-3 gap-2 flex-wrap">
              <span className="text-success fw-medium d-flex align-items-center">
                <Icon icon="bxs:up-arrow" className="me-1" width="12" />
                +NA%
              </span>
              <span className="text-muted small text-capitalize">This month</span>
            </div>
          </div>
        </div>
      </div>

      <div className="col">
        <div className="card shadow-none border h-100">
          <div className="card-body p-3">
            <div className="d-flex justify-content-between align-items-start gap-3 mb-2">
              <div className="min-w-0">
                <p className="text-muted fw-medium mb-3">Active Users</p>
                <h4 className="mb-0 text-break">{activeUsers}</h4>
              </div>
              <div className="bg-success bg-opacity-10 p-2 rounded flex-shrink-0">
                <Icon icon="fluent-color:people-community-48" className="text-success" width="24" />
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-between mt-3 gap-2 flex-wrap">
              <span className="text-success fw-medium d-flex align-items-center">
                +{yesterdaysActiveUserCount}%
              </span>
              <span className="text-muted small text-capitalize">From yesterday</span>
            </div>
          </div>
        </div>
      </div>

      <div className="col">
        <div className="card shadow-none border h-100">
          <div className="card-body p-3">
            <div className="d-flex justify-content-between align-items-start gap-3 mb-2">
              <div className="min-w-0">
                <p className="text-muted fw-medium mb-3">Weather Alert Sent</p>
                <h4 className="mb-0 text-break">{weatherAlerts}</h4>
              </div>
              <div className="bg-info bg-opacity-10 p-2 rounded flex-shrink-0">
                <Icon icon="fluent-color:weather-sunny-low-20" className="text-info" width="24" />
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-between mt-3 gap-2 flex-wrap">
              <span className="text-success fw-medium d-flex align-items-center">
                +{yesterdaysWeatherCount}%
              </span>
              <span className="text-muted small text-capitalize">From today</span>
            </div>
          </div>
        </div>
      </div>

      <div className="col">
        <div className="card shadow-none border h-100">
          <div className="card-body p-3">
            <div className="d-flex justify-content-between align-items-start gap-3 mb-2">
              <div className="min-w-0">
                <p className="text-muted fw-medium mb-3">Crop Advisory Alert Sent</p>
                <h4 className="mb-0 text-break">{cropAdvisoryAlerts}</h4>
              </div>
              <div className="flex-shrink-0">
                <Icon icon="fluent-color:alert-urgent-16" className="text-purple" width="24" />
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-between mt-3 gap-2 flex-wrap">
              <span className="text-success fw-medium d-flex align-items-center">
                +{yesterdaysAdvisoryCount}%
              </span>
              <span className="text-muted small text-capitalize">From last month</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnitCountOne;
